import React, {useState} from 'react';
import {Select, Slider, Switch} from 'antd';

const VideoParameters = () => {
    const [tabs, setTabs] = useState(1)
    const onChange = () => {
      
    }
    return (
        <div className="main-padding video-parameteres">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>Video Parameters</span>
            </div>
            <div className="camera-config-content">
                <div className="row">
                    <div className="col-md-6 p-2">

                    </div>
                    <div className="col-md-6 p-2">
                     <div className="d-flex justify-content-center">
                         <div className="btn-group">
                             <button onClick={() => setTabs(1)} className={tabs === 1 ? "btn btn-success" : "btn btn-light"}>Basic Parameters</button>
                             <button onClick={() => setTabs(2)}  className={tabs === 2 ? "btn btn-success" : "btn btn-light"}>Advanced Parameters</button>
                             <button onClick={() => setTabs(3)}  className={tabs === 3 ? "btn btn-success" : "btn btn-light"}>Infrared Settings</button>
                         </div>
                     </div>

                        {
                            tabs === 1 ?
                                <div className="my-slider">
                                    <div className="row mt-3 align-items-center">
                                        <div className="col-md-3 text-end text-white">Tonal</div>
                                        <div className="col-md-4">
                                            <Slider defaultValue={30}    />
                                        </div>
                                        <div className="col-md-5">
                                            <div className="number-counter">
                                                <span className="minus">-</span>
                                                <input type="text" value="1"/>
                                                <span className="plus">+</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 align-items-center">
                                        <div className="col-md-3 text-end text-white">Brightness</div>
                                        <div className="col-md-4">
                                            <Slider defaultValue={30}    />
                                        </div>
                                        <div className="col-md-5">
                                            <div className="number-counter">
                                                <span className="minus">-</span>
                                                <input type="text" value="1"/>
                                                <span className="plus">+</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 align-items-center">
                                        <div className="col-md-3 text-end text-white">Sharpness</div>
                                        <div className="col-md-4">
                                            <Slider defaultValue={30}    />
                                        </div>
                                        <div className="col-md-5">
                                            <div className="number-counter">
                                                <span className="minus">-</span>
                                                <input type="text" value="1"/>
                                                <span className="plus">+</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 align-items-center">
                                        <div className="col-md-3 text-end text-white">Gain</div>
                                        <div className="col-md-4">
                                            <Slider defaultValue={30}    />
                                        </div>
                                        <div className="col-md-5">
                                            <div className="number-counter">
                                                <span className="minus">-</span>
                                                <input type="text" value="1"/>
                                                <span className="plus">+</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 align-items-center">
                                        <div className="col-md-3 text-end text-white">Contrast</div>
                                        <div className="col-md-4">
                                            <Slider defaultValue={30}    />
                                        </div>
                                        <div className="col-md-5">
                                            <div className="number-counter">
                                                <span className="minus">-</span>
                                                <input type="text" value="1"/>
                                                <span className="plus">+</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 align-items-center">
                                        <div className="col-md-3 text-end text-white">Saturation</div>
                                        <div className="col-md-4">
                                            <Slider defaultValue={30}    />
                                        </div>
                                        <div className="col-md-5">
                                            <div className="number-counter">
                                                <span className="minus">-</span>
                                                <input type="text" value="1"/>
                                                <span className="plus">+</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 align-items-center">
                                        <div className="col-md-3 text-end text-white">BacklightCompensation</div>
                                        <div className="col-md-4">
                                            <Slider defaultValue={30}    />
                                        </div>
                                        <div className="col-md-5">
                                            <div className="number-counter">
                                                <span className="minus">-</span>
                                                <input type="text" value="1"/>
                                                <span className="plus">+</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 align-items-center">
                                        <div className="col-md-3 text-end text-white">Remove Fog</div>
                                        <div className="col-md-4">
                                            <Slider defaultValue={30}    />
                                        </div>
                                        <div className="col-md-5">
                                            <div className="number-counter">
                                                <span className="minus">-</span>
                                                <input type="text" value="1"/>
                                                <span className="plus">+</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 align-items-center">
                                        <div className="col-md-3 text-end text-white">Exposure Time</div>
                                        <div className="col-md-4">
                                            <Slider defaultValue={30}    />
                                        </div>
                                        <div className="col-md-5">
                                            <div className="number-counter">
                                                <span className="minus">-</span>
                                                <input type="text" value="1"/>
                                                <span className="plus">+</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 align-items-center">
                                        <div className="col-md-3 text-end">
                                            <label  className="text-white">
                                                Bitrate Type
                                            </label>
                                        </div>
                                        <div className="col-md-4 d-flex align-items-center">
                                            <Select

                                                placeholder="Поиск, чтобы выбрать"
                                                optionFilterProp="children"
                                                className="w-100"

                                            >
                                                <option value="1">asd</option>
                                                <option value="3">asd</option>
                                                <option value="2">asd</option>
                                            </Select>
                                            <span className="text-white ml-8">(S)</span>
                                        </div>
                                    </div>
                                </div>
                                :
                                tabs === 2 ?
                                    <div>


                                    <div className="row mt-3">
                                        <div className="col-md-4 text-end text-white">Mirror</div>
                                        <div className="col-md-8"><Switch defaultChecked onChange={onChange}/></div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-4 text-end text-white">Flip</div>
                                        <div className="col-md-8"><Switch defaultChecked onChange={onChange}/></div>
                                    </div>
                                        <div className="row mt-3 align-items-center">
                                            <div className="col-md-4 text-end">
                                                <label  className="text-white">
                                                    Video Format
                                                </label>
                                            </div>
                                            <div className="col-md-4">
                                                <Select

                                                    placeholder="Поиск, чтобы выбрать"
                                                    optionFilterProp="children"
                                                    className="w-100"

                                                >
                                                    <option value="1">asd</option>
                                                    <option value="3">asd</option>
                                                    <option value="2">asd</option>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="row mt-3 align-items-center">
                                            <div className="col-md-4 text-end">
                                                <label  className="text-white">
                                                    Color Turned
                                                </label>
                                            </div>
                                            <div className="col-md-4">
                                                <Select

                                                    placeholder="Поиск, чтобы выбрать"
                                                    optionFilterProp="children"
                                                    className="w-100"

                                                >
                                                    <option value="1">asd</option>
                                                    <option value="3">asd</option>
                                                    <option value="2">asd</option>
                                                </Select>
                                            </div>
                                        </div>
                                    <div className="row mt-3">
                                        <div className="col-md-4 text-end">
                                            <label  className="text-white">
                                                Black
                                            </label>
                                        </div>
                                    </div>
                                        <div className="row mt-3 align-items-center">
                                            <div className="col-md-4 text-end">
                                                <label  className="text-white">
                                                    Video Detection
                                                </label>
                                            </div>
                                            <div className="col-md-4">
                                                <Select

                                                    placeholder="Поиск, чтобы выбрать"
                                                    optionFilterProp="children"
                                                    className="w-100"

                                                >
                                                    <option value="1">asd</option>
                                                    <option value="3">asd</option>
                                                    <option value="2">asd</option>
                                                </Select>
                                            </div>
                                        </div>
                                    <div className="row mt-3">
                                        <div className="col-md-4 text-end text-white">Lens Correction</div>
                                        <div className="col-md-8"><Switch defaultChecked onChange={onChange}/></div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-4 text-end text-white">Automatic Aperture
                                        </div>
                                        <div className="col-md-8"><Switch defaultChecked onChange={onChange}/></div>
                                    </div>
                                        <div className="row mt-3 align-items-center my-slider">
                                            <div className="col-md-3 text-end text-white">Wide Dynamic Strength</div>
                                            <div className="col-md-4">
                                                <Slider defaultValue={30}    />
                                            </div>
                                            <div className="col-md-5">
                                                <div className="number-counter">
                                                    <span className="minus">-</span>
                                                    <input type="text" value="1"/>
                                                    <span className="plus">+</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    : tabs === 3 ?
                                        <div>
                                            <div className="row mt-3 align-items-center">
                                                <div className="col-md-3 text-end text-white">IRCUT Level (Low/High) </div>
                                                <div className="col-md-4">
                                                    <Switch defaultChecked onChange={onChange}/>
                                                </div>

                                            </div>

                                            <div className="row mt-3 align-items-center">
                                                <div className="col-md-3 text-end text-white">Photosensitive Level (Low/High) </div>
                                                <div className="col-md-4">
                                                    <Switch defaultChecked onChange={onChange}/>
                                                </div>

                                            </div>

                                            <div className="row mt-3 align-items-center">
                                                <div className="col-md-3 text-end text-white">Infrared Light Level (Low/High) </div>
                                                <div className="col-md-4">
                                                    <Switch defaultChecked onChange={onChange}/>
                                                </div>

                                            </div>
                                            <div className="row mt-3 align-items-center">
                                                <div className="col-md-3 text-end">
                                                    <label  className="text-white">
                                                        IR Control
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select

                                                        placeholder="Поиск, чтобы выбрать"
                                                        optionFilterProp="children"
                                                        className="w-100"

                                                    >
                                                        <option value="1">asd</option>
                                                        <option value="3">asd</option>
                                                        <option value="2">asd</option>
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="row mt-3 align-items-center my-slider">
                                                <div className="col-md-3 text-end text-white">Infrared Light Brightness</div>
                                                <div className="col-md-4">
                                                    <Slider defaultValue={30}    />
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="number-counter">
                                                        <span className="minus">-</span>
                                                        <input type="text" value="1"/>
                                                        <span className="plus">+</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3 align-items-center">
                                                <div className="col-md-3 text-end">
                                                    <label  className="text-white">
                                                        White Light Control
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select

                                                        placeholder="Поиск, чтобы выбрать"
                                                        optionFilterProp="children"
                                                        className="w-100"

                                                    >
                                                        <option value="1">asd</option>
                                                        <option value="3">asd</option>
                                                        <option value="2">asd</option>
                                                    </Select>
                                                </div>
                                            </div>
                                            <div className="row mt-3 align-items-center my-slider">
                                                <div className="col-md-3 text-end text-white">White Light Start Threshold</div>
                                                <div className="col-md-4">
                                                    <Slider defaultValue={30}    />
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="number-counter">
                                                        <span className="minus">-</span>
                                                        <input type="text" value="1"/>
                                                        <span className="plus">+</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3 align-items-center my-slider">
                                                <div className="col-md-3 text-end text-white">Lighting Brightness</div>
                                                <div className="col-md-4">
                                                    <Slider defaultValue={30}    />
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="number-counter">
                                                        <span className="minus">-</span>
                                                        <input type="text" value="1"/>
                                                        <span className="plus">+</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    :
                                ""
                        }
                        <div className="mt-5">
                            <button className="btn btn-primary mr-24">Default Parameters</button>
                            <button className="btn btn-primary">SET</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VideoParameters;